jQuery(window).on("load", function () {
  jQuery(".modal-job-video").on("hidden.bs.modal", function () {
    var memory = $(this).html();
    jQuery(this).html(memory);
  });
});
